var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-progress-circular',{staticClass:"mx-3",attrs:{"indeterminate":"","color":"primary"}}),(_vm.text)?_c('span',{domProps:{"textContent":_vm._s(_vm.text)}}):_c('span',[_vm._v("Just a moment...")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }